import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const TRUST_POINTS = [
  'Built for Malaysian fresh graduates',
  'Uses real EPF and PTPTN rules',
  'Free — no signup needed for first plan',
];

const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#E5E5EB] py-4">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 flex items-center justify-between">
          <h1 className="text-2xl font-black tracking-tighter" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            Clarity
          </h1>
          {user ? (
            <button
              data-testid="nav-dashboard-btn"
              onClick={() => navigate('/dashboard')}
              className="bg-[#534AB7] text-white hover:bg-[#423B99] rounded-full px-5 py-2 text-sm font-semibold transition-colors"
            >
              My Dashboard
            </button>
          ) : (
            <button
              data-testid="nav-login-btn"
              onClick={() => navigate('/auth', { state: { mode: 'login' } })}
              className="text-[#0A0A0B] hover:text-[#534AB7] font-semibold text-sm transition-colors"
            >
              Log in
            </button>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 sm:py-32">
        <div className="max-w-5xl mx-auto px-6 sm:px-8">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-[#0A0A0B] leading-none mb-8">
              Finally know exactly<br />what to do with<br />your money.
            </h1>

            <p className="text-base md:text-lg text-[#5C5C66] leading-relaxed mb-8 max-w-2xl mx-auto">
              Answer five quick questions. Get your personalised Malaysian financial action plan in 30 seconds.
            </p>

            {/* Trust points */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 mb-12" data-testid="trust-points">
              {TRUST_POINTS.map((point) => (
                <div key={point} className="flex items-center gap-2 text-sm font-medium text-[#5C5C66]">
                  <CheckCircle2 size={16} className="text-[#534AB7] flex-shrink-0" />
                  {point}
                </div>
              ))}
            </div>

            <button
              data-testid="landing-cta-btn"
              onClick={() => navigate('/app')}
              className="bg-[#534AB7] text-white hover:bg-[#423B99] hover:-translate-y-0.5 transition-transform duration-200 rounded-xl px-8 py-4 font-semibold text-lg inline-flex items-center justify-center"
            >
              Get My Plan Free
            </button>
          </motion.div>
        </div>
      </section>

      {/* Subtle accent image */}
      <div className="fixed bottom-0 right-0 w-1/3 h-1/3 opacity-5 pointer-events-none mix-blend-multiply">
        <img
          src="https://images.unsplash.com/photo-1454117096348-e4abbeba002c?w=800"
          alt=""
          className="w-full h-full object-cover grayscale"
        />
      </div>
    </div>
  );
};

export default LandingPage;
